import { pushProductQuickView } from "./utils";

const initDataLayerEvents = () => {
    document.addEventListener("dataLayer.quickViewDetail", function (data) {
        const eventData = data?.detail;
        const impression = eventData?.productImpression;

        const productImpression = Object.assign({}, {
            "name":impression?.name,
            "id":impression?.id,
            "price": impression?.price,
            "brand": impression?.brand,
            "category": impression?.category,
            "variant": impression?.variant,
            "position": eventData?.position
        });
        pushProductQuickView([productImpression], eventData.list);
    });
};


module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
